export class FolderHistoryQuery {
    current;
    pageSize;
}
